// Textbausteine / Snippets (Runde 8, Agent 8D): Typen und Client nach crm/API.md, Abschnitt 23.4. 8D erweitert diese Datei nur additiv.
import { http } from "./client";

export type BausteinKanal = "alle" | "email" | "sms" | "notiz";

export interface Textbaustein {
  id: string;
  kuerzel: string;
  name: string;
  inhalt: string;
  kanal: BausteinKanal;
  besitzer_id: string | null;
  besitzer_name?: string | null;
  geteilt: boolean;
  nutzungen: number;
  /** zusätzlich zum Vertrag: gehört der Baustein der angemeldeten Person? */
  eigener?: boolean;
  /** zusätzlich zum Vertrag: darf die angemeldete Person ihn ändern (geteilte nur mit dem Recht, private nur der Besitzer)? */
  bearbeitbar?: boolean;
}

export interface BausteinEingabe {
  kuerzel: string;
  name: string;
  inhalt: string;
  kanal?: BausteinKanal;
  geteilt?: boolean;
}

const k = encodeURIComponent;

export const textbausteineApi = {
  liste: (p: { kanal?: BausteinKanal; q?: string } = {}) => http.get<{ data: Textbaustein[] }>("/api/textbausteine", p),
  anlegen: (e: BausteinEingabe) => http.post<{ baustein: Textbaustein }>("/api/textbausteine", e),
  aendern: (id: string, e: Partial<BausteinEingabe>) => http.patch<{ baustein: Textbaustein }>(`/api/textbausteine/${k(id)}`, e),
  loeschen: (id: string) => http.del<void>(`/api/textbausteine/${k(id)}`),
  genutzt: (id: string) => http.post<void>(`/api/textbausteine/${k(id)}/genutzt`),
};
